import { type PhoneNumber } from '@egw/api'
import { type CountryCode, parsePhoneNumberWithError } from 'libphonenumber-js'

export function removeCountryCodeFromPhoneNumber(phone: string | undefined, country: CountryCode = 'US'): string {
  if (!phone) return ''

  const splitNumber = parsePhoneNumberWithError(phone, country).formatInternational().split(' ')

  splitNumber.shift()
  return splitNumber.join('')
}

export const getFullPhoneNumber = (phone?: PhoneNumber): string => {
  if (!phone) return ''

  return `+${phone.countryPhoneCode.toString()}${phone.phoneNumber}`
}

export function formatPhoneNumberString(phone: string | undefined, country: CountryCode = 'US'): string {
  if (!phone) return ''

  // example format from design is +# (###) ### ####
  // this is a mix of international +# ### ### ####
  // and national (###) ### ####
  // since we only support US for now, I can wrap
  // the second part of the string in parenthesis to achieve this effect
  const splitNumber = parsePhoneNumberWithError(phone, country).formatInternational().split(' ')
  splitNumber[1] = `(${splitNumber[1]})`
  return splitNumber.join(' ')
}
